import React, {useState, useEffect} from 'react';
import * as classes from './MoreContent.module.scss'
import MediaQuery from 'react-responsive';
import { getFileName } from '../../helpers/FileCatching';
import Advert from "../Advert/Advert";
import IsNotDomestic from "../../helpers/IsNotDomestic";
import { trackCustomEvent } from "../../helpers/tracking";

const globalImages = require.context('../../images', true, /.*\.(gif|png|jpe?g|svg)$/i);
const contentImages = require.context('./images', true, /.*\.(gif|png|jpe?g|svg)$/i);

function MoreContent({content, GlobalData}) {

    function onPromoClick(title){
        let trackObject = {
          category: GlobalData.tracking.gaCategory,
          action: "Click",
          label: "Content " + title
        }
        trackCustomEvent(trackObject);
    }

    function onLoadClick(){
        let trackObject = {
          category: GlobalData.tracking.gaCategory,
          action: "Click",
          label: "Load More " + loadIndex
        }
        trackCustomEvent(trackObject);
    }

    let resultsPageLength = 6;
    let totalPages = Math.floor(content.articles.length/resultsPageLength)
    let [pageIndex, setPageIndex] = useState(0);
    let [loadIndex, setLoadIndex] = useState(0);
    const [resultsRender, setResultsRender] = useState([]);
    const [nextResultsPreview, setNextResultsPreview] = useState([]);

    useEffect(() => {
        loadMoreArticles()
    },[])

    function resultItem(item, index){
        return (
            <div key={index} className={classes.MoreContent__promoSlot}>
                <div className={classes.MoreContent__promoSlot__imageContainer}>
                    <a href={item.ctaURL} onClick={() => { onPromoClick(item.title) }}>
                        <img src={getFileName(contentImages,item.image).default} alt={item.imageAlt} className={classes.MoreContent__promoSlot__image}/>
                    </a>
                </div>
                <MediaQuery maxWidth={classes.screenLgMax}>
                    <div className={classes.MoreContent__promoSlot__textWrap}>
                        <a href={item.ctaURL} onClick={() => { onPromoClick(item.title) }}><h3 className={` ${classes.MoreContent__promoSlot__header} promoHeading`}>{item.heading}</h3></a>
                        <h2 className={` ${classes.MoreContent__promoSlot__title} promoTitle`}>{item.title}</h2>
                        <a href={item.ctaURL} onClick={() => { onPromoClick(item.title) }} className={`${classes.MoreContent__promoSlot__cta} button`}><p>{content.ctaText}</p></a>
                    </div>
                </MediaQuery>
                <MediaQuery minWidth={classes.screenLg}>
                    <a href={item.ctaURL} onClick={() => { onPromoClick(item.title) }}><h3 className={` ${classes.MoreContent__promoSlot__header} promoHeading`}>{item.heading}</h3></a>
                    <h2 className={` ${classes.MoreContent__promoSlot__title} promoTitle`}>{item.title}</h2>
                    <a href={item.ctaURL} onClick={() => { onPromoClick(item.title) }} className={`${classes.MoreContent__promoSlot__cta} button`}><p>{content.ctaText}</p></a>
                </MediaQuery>
            </div>
        )
    }
    
    function addNextResultsPreview(){
        let tempResultsRender = [...resultsRender]
        let sliceStart = (pageIndex*resultsPageLength)+resultsPageLength
        let sliceEnd = sliceStart+3

        setNextResultsPreview(
            <div className={`${classes.MoreContent__promoSlotContainer} ${classes.MoreContent__promoSlotContainerPreview}`}>
                {
                    content.articles.slice(sliceStart, sliceEnd)
                    .map((item, index) => (
                        resultItem(item,index)
                    ))
                }
                <div className={` ${classes.MoreContent__promoSlotContainerPreviewmask}`}></div>
            </div>
        )
    }

    function addResults(){
        let tempResultsRender = [...resultsRender]
        let sliceStart = (pageIndex*resultsPageLength)
        let sliceEnd = (pageIndex*resultsPageLength)+resultsPageLength
        tempResultsRender.push(
            <div key={tempResultsRender.length+1} className={classes.MoreContent__promoSlotContainer}>
                {
                content.articles.slice(sliceStart, sliceEnd)
                    .map((item, index) => (
                        resultItem(item,index)
                    ))
                }
                <IsNotDomestic>
                    <div className={classes.MoreContent__promoSlotAdvert}>
                        <Advert adData={GlobalData.advertising} column={"delta"+(pageIndex+2)}/>
                    </div>
                </IsNotDomestic>
            </div>
        )
        setResultsRender(tempResultsRender)
    }

    function loadMoreArticles(){
        addResults()
        addNextResultsPreview()
        setPageIndex(pageIndex+1)
        setLoadIndex(loadIndex+1)
        onLoadClick()
    }
    
    return (
        <div className={`${classes.MoreContent}`}>
            <div className={`${classes.MoreContent__wrapper}`}>
                
                {resultsRender}
                {nextResultsPreview}
                {
                    (
                        pageIndex<totalPages+1
                        ?
                        <div className={`${classes.MoreContent__loadMore} button`}><p onClick={() => {loadMoreArticles() }}>Load More <img src={getFileName(globalImages,'+.svg').default} alt={'More'}/></p></div>
                        :
                        <></>
                    )
                }
               

            </div>
        </div>
    );
}

export default MoreContent;